import apiClient from './client'

export const profileApi = {
  getProfile: () =>
    apiClient.get('/profile').then((r) => r.data),

  updateClientProfile: (data: Record<string, unknown>) =>
    apiClient.put('/client/profile', data).then((r) => r.data),

  uploadResume: (file: File) => {
    const fd = new FormData()
    fd.append('file', file)
    return apiClient
      .post('/client/profile/resume', fd, {
        headers: { 'Content-Type': undefined },
      })
      .then((r) => r.data)
  },

  changePassword: (data: {
    current_password: string
    new_password: string
    new_password_confirmation: string
  }) =>
    apiClient.put('/client/password', data).then((r) => r.data),

  getNotificationPrefs: () =>
    apiClient
      .get('/client/notification-preferences')
      .then((r) => r.data),

  updateNotificationPrefs: (data: Record<string, unknown>) =>
    apiClient
      .put('/client/notification-preferences', data)
      .then((r) => r.data),
}
